import React from 'react';
import { Draggable } from 'react-beautiful-dnd';

import { OptionItemObject } from '../../../../../../src/shared_models/interfaces';

import { OptionsListProperties } from './interfaces';
import OptionItem from './OptionItem';

const OptionsList: React.FC<OptionsListProperties> = ({
    onChange,
    optionsWithUpdatedName,
    options,
    onConfigureOptionsClick,
    handleDeleteOptionClick,
    nestingLevelChanged,
    currentNestingLevel,
    locale,
}) => {
    return (
        <>
            {options.map((option: OptionItemObject, index) => (
                <Draggable
                    key={index}
                    draggableId={index.toString()}
                    index={index}
                >
                    {provided => (
                        <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                        >
                            <OptionItem
                                onChange={onChange}
                                optionsWithUpdatedName={optionsWithUpdatedName}
                                isDefaultOption={option.isDefaultOption}
                                value={option.value}
                                isEnabled={option.isEnabled}
                                shouldAutoFocus={!option.value && index === options.length - 1}
                                optionIndex={index}
                                optionKey={option.key}
                                translation={option.translation}
                                onConfigureOptionsClick={onConfigureOptionsClick}
                                handleDeleteOptionClick={handleDeleteOptionClick}
                                currentNestingLevel={currentNestingLevel}
                                nestingLevelChanged={nestingLevelChanged}
                                locale={locale}
                                provided={provided}
                            />
                        </div>
                    )}
                </Draggable>
            ))}
        </>
    );
};

export default OptionsList;
